import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { UpdateTemplate } from '../Model/Catalog/UpdateTemplate';
import { CustomerWiki } from '../Model/System/CustomerWiki';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from '../Services/system.service';
import { Router } from '@angular/router';
import { UpdateTemplateService } from '../Services/updateTemplate.service';
import { CatalogService } from '../Services/CatalogManagement/catalog.service';
import { LoginService } from '../Services/login.service';
import { ExportConfigurationService } from '../Services/exportConfiguration.service';
import { SelectionChangedEvent } from 'devextreme/ui/data_grid';

@Component({
    selector: 'updateTemplates',
    templateUrl: 'updateTemplates.component.html',
    standalone: false
})
export class UpdateTemplatesComponent implements OnInit {
  @Input() helpSwitch?: boolean = true;
  @Input() templates: UpdateTemplate[];

  selectedRowKeys: UpdateTemplate[] = [];
  selectedTemplate: UpdateTemplate;

  @Input()
  get selectedTemplateId(): string {
    if (!this.selectedRowKeys || this.selectedRowKeys.length == 0)
      return null;
    return this.selectedRowKeys[0]?.id;
  }

  set selectedTemplateId(value: string) {
    console.log('selectedTemplateId changed to ' + value);
    const template = this.templates?.find(t => t.id === value);
    this.selectedRowKeys = template ? [template] : [];
    this.selectedTemplate = template;
    this.selectedTemplateIdChange.emit(value);
  }

  @Output() selectedTemplateIdChange = new EventEmitter<string>();


  constructor(
    public translate: TranslateService,
    public loginService: LoginService,
    public router: Router,
    public updateTemplateService: UpdateTemplateService,
    public catalogService: CatalogService,
    public systemService: SystemService,
    public exportConfigurationService: ExportConfigurationService
  ) {
    this.systemService.currentNavigationTitle = this.translate.instant('Update Templates');
  }

  ngOnInit(): void {
    if (this.loginService.currentUser == null) {
      this.router.navigate(['/']);
      return;
    }

    if (this.templates == null || this.templates.length == 0) {
      this.updateTemplateService.getUpdateTemplates().subscribe((result: UpdateTemplate[]) => {
        this.templates = result;
        if (this.templates?.length > 0) {
          this.selectedRowKeys = [this.templates[0]];
        }
      });
    }

    this.catalogService.loadFields();
  }

  get fields() {
    return this.catalogService.fields;
  }

  onDeleteClicked(e) {
    this.updateTemplateService.deleteUpdateTemplate(e.data);
  }

  addTemplate() {
    let updateTemplate = new UpdateTemplate();
    updateTemplate.customerId = this.loginService.currentUser.customerId;

    this.updateTemplateService.addUpdateTemplate(updateTemplate).subscribe((result: UpdateTemplate) => {
      this.templates = [...(this.templates ?? []), result];
      this.selectedTemplateId = result.id;
    });
  }

  toggleHelp() {
    this.systemService.showHelp = !this.systemService.showHelp;
    if (this.systemService.showHelp) {
      this.systemService
        .loadHelp(this.loginService.currentUser.customerId)
        .subscribe((result: CustomerWiki) => (this.systemService.help = result.entries));
    }
  }

  onSelectionChanged(event: SelectionChangedEvent) {
    if (event.selectedRowKeys && event.selectedRowKeys.length > 0)
      this.selectedTemplateId = event.selectedRowKeys[0].id;
  }
}
